import { render } from "./ForgotEmail.vue?vue&type=template&id=3b0a116a"
import script from "./ForgotEmail.vue?vue&type=script&lang=js"
export * from "./ForgotEmail.vue?vue&type=script&lang=js"

import "./ForgotEmail.vue?vue&type=style&index=0&id=3b0a116a&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__